import React from 'react';
import ExecutionEnvironment from 'exenv';

import { useFeature } from 'hooks/useFeature';
import { FEATURE_SITE_REDESIGN } from 'constants/features';
import { HYDRA_ZAPPOS_REDESIGN } from 'constants/hydraTests';
import { useInAssignment } from 'hooks/useHydra';

const THEME_ATTR = 'data-theme';
const THEME_VAL = 'zappos-redesign';

const Themer = () => {
  const isHydraZapposRedesign = useInAssignment(HYDRA_ZAPPOS_REDESIGN);
  const hasZapposRedesignFeature = useFeature(FEATURE_SITE_REDESIGN);

  if (!ExecutionEnvironment.canUseDOM) {
    return null;
  }

  const root = document.documentElement;

  if (isHydraZapposRedesign || hasZapposRedesignFeature) {
    root?.setAttribute(THEME_ATTR, THEME_VAL);
  } else {
    root?.removeAttribute(THEME_ATTR);
  }

  return null;
};

export default Themer;
